import React from 'react';

import { observer } from 'mobx-react';
import { Surface } from '@infoods/lifebase-ui';

import classes from './ClientsAnalyticsWidget.module.scss';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { ClientsInfoItem } from '../../../components/ClientsInfoItem/ClientsInfoItem';
import { ClientsGraph } from './ClientsGraph/ClientsGraph';
import { useClientAnalyticsData } from './hooks/useClientAnalyticsData';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';

const ClientsAnalyticsWidget = observer(() => {
  const { dateRangePreset, solutionTypeFilter } = entityDashboardFilterStore;
  const { clientAnalyticsData } = useClientAnalyticsData({
    dateRangePreset,
    solutionTypeFilter,
  });

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Client Analytics"
        tooltipContent={
          <>
            New vs returning customers
            <br />
            Includes ScanIQ + Nutrition
          </>
        }
      />
      {clientAnalyticsData && (
        <>
          <div className={classes.metricsContainer}>
            <ClientsInfoItem
              title="New Customers"
              value={clientAnalyticsData.newCustomers.value}
              diffPercent={clientAnalyticsData.newCustomers.diffPercent}
              hideComparisonPeriod
              indicatorColor="info-300"
            />
            <ClientsInfoItem
              title="Returning Customers"
              value={clientAnalyticsData.returningCustomers.value}
              diffPercent={clientAnalyticsData.returningCustomers.diffPercent}
              hideComparisonPeriod
              indicatorColor="info-100"
            />
            <ClientsInfoItem
              title="Active Customers"
              value={clientAnalyticsData.activeCustomers.value}
              diffPercent={clientAnalyticsData.activeCustomers.diffPercent}
              hideComparisonPeriod
            />
          </div>
          <ClientsGraph customersGraph={clientAnalyticsData.graphData} />
        </>
      )}
    </Surface>
  );
});

export { ClientsAnalyticsWidget };
